<template>
  <Modal v-bind:open="open" @close="close">
    <div>
      <h1 class="text-center font-extrabold text-xl">{{ $t("planSale.reactivation.title") }}</h1>

      <p class="mt-4 text-center text-gray-600">{{ $t("planSale.reactivation.description") }}</p>

      <div class="mt-4 flex justify-center">
        <GenericButton @click="handlePlanSaleReactivate">{{ $t("planSale.reactivation.confirm") }}</GenericButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, GenericButton } from "@estaly/ui";

export default {
  components: {
    Modal,
    GenericButton,
  },

  props: {
    open: { type: Boolean, required: true },
  },

  methods: {
    handlePlanSaleReactivate: function () {
      this.$emit("reactivatePlanSale");
    },

    close: function () {
      this.$emit("close");
    },
  },
};
</script>
